module.exports = __webpack_public_path__ + "static/2020全球人工智能治理年度观察中文版-b520ebb32e6a68aef294a30ca8c1cd99.pdf";